import { useConsultation } from '@entities/consultations';
import cn from 'classnames';
import { parseISO } from 'date-fns';
import type React from 'react';

import { Data, Icon, Status } from './frames';

// TODO refactor frames folder

import * as st from './styles.module.scss';

type Props = {
	id: number;
};

export const Card: React.FC<Props> = ({ id }) => {
	const { consultation } = useConsultation(id);

	const isNow = () => {
		if (!consultation) return;
		const start = parseISO(consultation.start_time);
		const end = parseISO(consultation.end_time);
		const now = new Date();
		return start <= now && now <= end;
	};

	return consultation ? (
		<div className={cn(st.consultation, isNow() && st.now)}>
			<section className={st.consultation__icon}>
				<Icon type={consultation?.type} />
			</section>
			<section className={st.consultation__data}>
				{consultation && (
					<Data
						type={consultation.type}
						start={consultation.start_time}
						status={<Status consultation={consultation} />}
					/>
				)}
			</section>
		</div>
	) : (
		<></>
	);
};
